<div class="ui-title-bar">
  <div class="ui-title-bar__main">
    <!-- ── Zona izquierda: título + subtítulo + breadcrumb ─────────────────── -->
    <div class="ui-title-bar__left">
      <div class="ui-title-bar__heading">
        <h2 class="ui-title-bar__title">
          <span class="ui-title-bar__title-default">{{ title() }}</span>
          @if (mobileTitle()) {
            <span class="ui-title-bar__title-mobile">
              <span class="ui-title-bar__title-line">{{ mobileTitle() }}</span>
              @if (mobileModel() || mobileUnit()) {
                <span class="ui-title-bar__title-line ui-title-bar__title-meta">
                  @if (mobileModel()) {
                    <span class="ui-title-bar__title-meta-row">
                      <span class="ui-title-bar__title-meta-label"
                        >Modelo:</span
                      >
                      <span class="ui-title-bar__title-meta-value">{{
                        mobileModel()
                      }}</span>
                    </span>
                  }
                  @if (mobileModel() && mobileUnit()) {
                    <span class="ui-title-bar__title-meta-separator">·</span>
                  }
                  @if (mobileUnit()) {
                    <span class="ui-title-bar__title-meta-row">
                      <span class="ui-title-bar__title-meta-label"
                        >Unidad:</span
                      >
                      <span class="ui-title-bar__title-meta-value">{{
                        mobileUnit()
                      }}</span>
                    </span>
                  }
                </span>
              } @else if (mobileSubtitle()) {
                <span class="ui-title-bar__title-line">{{
                  mobileSubtitle()
                }}</span>
              }
            </span>
          }
        </h2>
      </div>

      @if (breadcrumbItems().length || breadcrumbHome()) {
        <ui-breadcrumb
          [items]="breadcrumbItems()"
          [home]="breadcrumbHome()"
          [ariaLabel]="breadcrumbAriaLabel()"
          (itemSelect)="breadcrumbItemSelect.emit($event)"
        />
      }
    </div>

    <ng-content select="[data-ui-title-bar-before-end]" />

    <!-- ── Zona derecha: contenido proyectado (filtros / botones / libre) ──── -->
    <div class="ui-title-bar__end">
      <ng-content />
    </div>
  </div>

  <div
    class="ui-title-bar__second"
    [hidden]="mode() !== 'report' || !showSecondFilterRow()"
  >
    <div class="ui-title-bar__filters">
      <ng-content select="[data-ui-title-bar-row]" />
    </div>
    @if (showAdditionalFilterRows()) {
      <button
        type="button"
        class="ui-title-bar__expand"
        [attr.aria-expanded]="extraFiltersExpanded()"
        [attr.aria-label]="
          extraFiltersExpanded() ? 'Ocultar filtros' : 'Mostrar más filtros'
        "
        (click)="toggleExtraFilters()"
      >
        <span class="ui-title-bar__expand-icon" aria-hidden="true"></span>
      </button>
    }
  </div>

  <div
    class="ui-title-bar__more"
    [hidden]="
      mode() !== 'report' ||
      !showSecondFilterRow() ||
      !showAdditionalFilterRows() ||
      !extraFiltersExpanded()
    "
  >
    <ng-content select="[data-ui-title-bar-more]" />
  </div>
</div>
